module.exports = __webpack_public_path__ + "media/images/Pulse-1s-200px-c758c441f4c3679bcfd8e5233c441658.gif";